import { BaseModalProps } from "../BaseModal"
import { StepperModal } from "../StepperModal"
import { StepperModalValues } from "../StepperModal/StepperModalContext"

import AddFundsStep from "./AddFundsStep"
import BridgeReviewStep from "./BridgeReviewStep"
import SuccessfullyBridgedAssetsStep from "./SuccessfullyBridgedAssetStep"

type BridgeAssetStepperModalProps = BaseModalProps & {
  contextValue: StepperModalValues | undefined
}

export default function BridgeAssetStepperModal({
  contextValue,
  ...props
}: BridgeAssetStepperModalProps) {
  return (
    <StepperModal
      {...props}
      initialContextValue={contextValue}
      steps={[
        {
          title: "Add funds",
          withCloseButton: true,
          component: AddFundsStep,
        },
        {
          title: "Review",
          withCloseButton: true,
          component: BridgeReviewStep,
        },
        {
          title: "Successfully initiated bridging",
          component: SuccessfullyBridgedAssetsStep,
          withCloseButton: true,
          withBackButton: false,
        },
      ]}
      overrides={{
        Dialog: {
          style: () => ({
            width: "548px",
            height: "fit-content",
          }),
        },
      }}
    />
  )
}
